import { keyMirror } from 'redfish-core/lib/utils/utils.js'

export const actionTypes = keyMirror([
    'START_JOB',
    'COMPLETE_JOB',
    'RETRY_JOB',
    'ERROR_JOB',
])
